import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$body} from '../Constants';

/**
 * Javascript Wrapper for the Form HTMLElement
 */
class Form extends HtmlElement {
	onReady() {
		this.$fields = this.$element.find('input, select, textarea');

		this.bindHandlers();
	}

	bindHandlers() {
		if(this.$element.hasClass('form-custom')) {
			let _self = this;

			this.$fields.not('input[type="checkbox"]').not('input[type="radio"]').each(function() {
				_self.fieldHandleValueInput($(this));

				$(this).on('focus', function() {
					_self.fieldFocused($(this));
				});

				$(this).on('blur', function() {
					_self.fieldUnfocused($(this));
				});

				$(this).on('input', function() {
					_self.fieldHandleValueInput($(this));
				})
			});
		}
	}

	fieldFocused($field) {
		$field.parent('.input-wrap').addClass('field-focused');
	}

	fieldUnfocused($field) {
		$field.parent('.input-wrap').removeClass('field-focused');
	}

	fieldHandleValueInput($field) {
		if($field.val() !== '') {
			$field.parent('.input-wrap').addClass('field-has-value');
		}else {
			$field.parent('.input-wrap').removeClass('field-has-value');
		}
	}
}

export default (new Form($body.find('form')));